import React, { useState } from 'react';
import CargasTable from './CargasTable';
import '../styles/PersonalDataForm.css';

const PersonalDataForm = ({ onDataSubmit, onBack, initialData, planSeleccionado }) => {
  const [formData, setFormData] = useState(initialData || {
    nombreCompleto: '',
    rut: '',
    fechaNacimiento: '',
    correo: '',
    celular: '',
    esColegiado: '',
    colegiaturaAlDia: '',
    comentarios: ''
  });
  
  const [cargasData, setCargasData] = useState(initialData?.cargas || []);

  const [errors, setErrors] = useState({});

  const validateRUT = (rut) => {
    // 1. Limpiar el RUT (remover puntos y guión)
    const cleanRut = rut.replace(/\./g, '').replace('-', '');
    if (cleanRut.length < 8 || cleanRut.length > 9) return false;
    
    // 2. Separar el cuerpo y el dígito verificador (DV)
    const rutBody = cleanRut.slice(0, -1);  // Parte numérica (todos menos el último)
    const dv = cleanRut.slice(-1).toLowerCase();  // Último dígito/letra
    
    console.log('RUT original:', rut);
    console.log('RUT limpio:', cleanRut);
    console.log('Cuerpo:', rutBody);
    console.log('DV ingresado:', dv);
    
    let sum = 0;
    let multiplier = 2;
    
    // Multiplicar cada dígito del cuerpo por factor 2-7 (desde derecha a izquierda)
    for (let i = rutBody.length - 1; i >= 0; i--) {
      sum += parseInt(rutBody[i]) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }
    
    // Dividir la suma entre 11 y obtener el resto
    const remainder = sum % 11;
    console.log('remainder:', remainder);
    
    // Calcular dígito verificador: 11 - resto
    const dvCalculated = 11 - remainder;
    let calculatedDv;
    
    if (dvCalculated === 11) {
      calculatedDv = '0';
    } else if (dvCalculated === 10) {
      calculatedDv = 'k';
    } else {
      calculatedDv = dvCalculated.toString();
    }
    
    console.log('DV calculado:', calculatedDv);
    
    return dv === calculatedDv;
  };

  const formatRUT = (value) => {
    // Remover todo excepto números y K/k
    const cleanValue = value.replace(/[^0-9kK]/g, '');
    
    if (cleanValue.length <= 1) {
      // Solo permitir números en el primer carácter
      return cleanValue.replace(/[kK]/g, '');
    }
    
    // Separar cuerpo y dígito verificador
    const rutBody = cleanValue.slice(0, -1).replace(/[kK]/g, ''); // Solo números en el cuerpo
    const dv = cleanValue.slice(-1); // Puede ser número o K/k
    
    // Formatear con puntos
    const formattedBody = rutBody.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${formattedBody}-${dv}`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'rut') {
      const formattedRut = formatRUT(value);
      setFormData(prev => ({ ...prev, [name]: formattedRut }));
    } else if (name === 'celular') {
      const numericValue = value.replace(/\D/g, '');
      setFormData(prev => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.nombreCompleto.trim()) {
      newErrors.nombreCompleto = 'El nombre completo es requerido';
    }

    if (!formData.rut.trim()) {
      newErrors.rut = 'El RUT es requerido';
    } else if (!validateRUT(formData.rut)) {
      newErrors.rut = 'RUT inválido';
    }

    if (!formData.fechaNacimiento) {
      newErrors.fechaNacimiento = 'La fecha de nacimiento es requerida';
    }

    if (!formData.correo.trim()) {
      newErrors.correo = 'El correo es requerido';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.correo)) {
      newErrors.correo = 'Correo inválido';
    }

    if (!formData.celular.trim()) {
      newErrors.celular = 'El celular es requerido';
    } else if (formData.celular.length < 8) {
      newErrors.celular = 'Celular debe tener al menos 8 dígitos';
    }

    if (!formData.esColegiado) {
      newErrors.esColegiado = 'Debe seleccionar una opción';
    }

    if (!formData.colegiaturaAlDia) {
      newErrors.colegiaturaAlDia = 'Debe seleccionar una opción';
    }

    return newErrors;
  };

  const handleCargasChange = (newCargasData) => {
    setCargasData(newCargasData);
  };

  const validateCargas = () => {
    const cargasErrors = [];
    
    cargasData.forEach((carga, index) => {
      const cargaErrors = {};
      
      // Si la carga no está completamente vacía, validar campos llenos
      const hasAnyData = carga.rut.trim() || carga.nombres.trim() || carga.fechaNacimiento.trim();
      
      if (hasAnyData) {
        // Si tiene algún dato, todos deben estar completos
        if (!carga.rut.trim()) cargaErrors.rut = 'RUT requerido';
        if (!carga.nombres.trim()) cargaErrors.nombres = 'Nombres requeridos';
        if (!carga.fechaNacimiento.trim()) cargaErrors.fechaNacimiento = 'Fecha requerida';
        
        // Validar RUT si existe
        if (carga.rut.trim() && !validateRUT(carga.rut)) {
          cargaErrors.rut = 'RUT inválido';
        }
      }
      
      if (Object.keys(cargaErrors).length > 0) {
        cargasErrors[index] = cargaErrors;
      }
    });
    
    return cargasErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    const cargasErrors = validateCargas();
    
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    // Mostrar errores de cargas si existen
    if (Object.keys(cargasErrors).length > 0) {
      // Actualizar errores en las cargas
      const updatedCargas = cargasData.map((carga, index) => ({
        ...carga,
        errors: cargasErrors[index] || {}
      }));
      setCargasData(updatedCargas);
      return;
    }

    if (onDataSubmit) {
      onDataSubmit({
        ...formData,
        cargas: cargasData
      });
    }
  };

  return (
    <div className="personal-data-container">
      <div className="form-header">
        <h1>Datos Personales</h1>
        <p>Ingrese su información personal para completar la pre-inscripción</p>
      </div>

      <form onSubmit={handleSubmit} className="personal-data-form">
        <div className="form-group">
          <label htmlFor="nombreCompleto" className="form-label">
            Nombre Completo *
          </label>
          <input
            type="text"
            id="nombreCompleto"
            name="nombreCompleto"
            value={formData.nombreCompleto}
            onChange={handleInputChange}
            className={`form-input ${errors.nombreCompleto ? 'error' : ''}`}
            placeholder="Ingrese su nombre completo"
          />
          {errors.nombreCompleto && <span className="error-message">{errors.nombreCompleto}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="rut" className="form-label">
            RUT *
          </label>
          <input
            type="text"
            id="rut"
            name="rut"
            value={formData.rut}
            onChange={handleInputChange}
            className={`form-input ${errors.rut ? 'error' : ''}`}
            placeholder="12.345.678-9 o 12.345.678-K"
            maxLength="12"
          />
          {errors.rut && <span className="error-message">{errors.rut}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="fechaNacimiento" className="form-label">
            Fecha de Nacimiento *
          </label>
          <input
            type="date"
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={formData.fechaNacimiento}
            onChange={handleInputChange}
            className={`form-input ${errors.fechaNacimiento ? 'error' : ''}`}
          />
          {errors.fechaNacimiento && <span className="error-message">{errors.fechaNacimiento}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="correo" className="form-label">
            Correo Electrónico *
          </label>
          <input
            type="email"
            id="correo"
            name="correo"
            value={formData.correo}
            onChange={handleInputChange}
            className={`form-input ${errors.correo ? 'error' : ''}`}
            placeholder="ejemplo@correo.com"
          />
          {errors.correo && <span className="error-message">{errors.correo}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="celular" className="form-label">
            Celular *
          </label>
          <input
            type="tel"
            id="celular"
            name="celular"
            value={formData.celular}
            onChange={handleInputChange}
            className={`form-input ${errors.celular ? 'error' : ''}`}
            placeholder="912345678"
            maxLength="9"
          />
          {errors.celular && <span className="error-message">{errors.celular}</span>}
        </div>

        <div className="form-group">
          <label className="form-label">
            ¿Eres Soci@ del Colegio de Ingenieros? *
          </label>
          <div className="radio-group">
            <label className="radio-label">
              <input
                type="radio"
                name="esColegiado"
                value="S"
                checked={formData.esColegiado === 'S'}
                onChange={handleInputChange}
                className="radio-input"
              />
              <span>Sí</span>
            </label>
            <label className="radio-label">
              <input
                type="radio"
                name="esColegiado"
                value="N"
                checked={formData.esColegiado === 'N'}
                onChange={handleInputChange}
                className="radio-input"
              />
              <span>No</span>
            </label>
          </div>
          {errors.esColegiado && <span className="error-message">{errors.esColegiado}</span>}
        </div>

        <div className="form-group">
          <label className="form-label">
            ¿Se encuentra al día en el pago de la colegiatura? *
          </label>
          <div className="radio-group">
            <label className="radio-label">
              <input
                type="radio"
                name="colegiaturaAlDia"
                value="S"
                checked={formData.colegiaturaAlDia === 'S'}
                onChange={handleInputChange}
                className="radio-input"
              />
              <span>Sí</span>
            </label>
            <label className="radio-label">
              <input
                type="radio"
                name="colegiaturaAlDia"
                value="N"
                checked={formData.colegiaturaAlDia === 'N'}
                onChange={handleInputChange}
                className="radio-input"
              />
              <span>No</span>
            </label>
          </div>
          {errors.colegiaturaAlDia && <span className="error-message">{errors.colegiaturaAlDia}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="comentarios" className="form-label">
            Comentarios
          </label>
          <textarea
            id="comentarios"
            name="comentarios"
            value={formData.comentarios}
            onChange={handleInputChange}
            className="form-textarea"
            placeholder="Ingrese comentarios adicionales (opcional)"
            rows="4"
          />
        </div>

        <CargasTable 
          planSeleccionado={planSeleccionado}
          onCargasChange={handleCargasChange}
          initialCargas={cargasData}
        />

        <div className="form-actions">
          <button 
            type="button" 
            onClick={onBack}
            className="back-btn"
          >
            Volver
          </button>
          <button 
            type="submit" 
            className="continue-btn"
          >
            Continuar
          </button>
        </div>
      </form>
    </div>
  );
};

export default PersonalDataForm;